import { render, staticRenderFns } from "./orderDisplayOriginalDetails.vue?vue&type=template&id=ae6b7e60&scoped=true&"
import script from "./orderDisplayOriginalDetails.vue?vue&type=script&lang=js&"
export * from "./orderDisplayOriginalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6b7e60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae6b7e60')) {
      api.createRecord('ae6b7e60', component.options)
    } else {
      api.reload('ae6b7e60', component.options)
    }
    module.hot.accept("./orderDisplayOriginalDetails.vue?vue&type=template&id=ae6b7e60&scoped=true&", function () {
      api.rerender('ae6b7e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/orderDisplayOriginalDetails.vue"
export default component.exports